// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__33rMB","left":"StickyBox_left__keFzs","right":"StickyBox_right__niXkh"};